import * as React from "react";
import {none, Option, option} from "ts-option";
import FormGroup from "../../hiberUiKit/src/molecules/FormGroup/FormGroup";
import DropDown from "../../hiberUiKit/src/molecules/DropDown/DropDown";
import {LabelableProps} from "../common/props/LabelableProps";
import {FormGroupProps} from "../common/props/FormGroupProps";

interface ComponentProps {
	items?: BooleanDropDownValue[]
}

type Props = FormGroupProps<boolean> & LabelableProps & ComponentProps

export default class BooleanFormGroup extends React.PureComponent<Props> {
	items: BooleanDropDownValue[] = [
		{label: "Please select", value: none},
		{label: "No", value: option(false)},
		{label: "Yes", value: option(true)}];

	constructor(props: Props) {
		super(props);
		if (props.items) {
			this.items = props.items
		}
	}

	render() {
		return (
			<FormGroup label={this.props.label}
					   error={this.props.field.firstError().orNull}
					   customClass={"c-boolean-form-group"}>
				<DropDown items={this.items}
						  itemToLabel={(item: BooleanDropDownValue) => item.label}
						  itemToId={(item: BooleanDropDownValue) => item.value.map(v => `${v}`).getOrElse("-1")}
						  onSelect={this.onChange}
						  selectedItemId={this.props.field.getOptionalValue().map(v => `${v}`).getOrElse("-1")}/>
			</FormGroup>
		)
	}

	onChange = (item: BooleanDropDownValue) => {
		this.props.onChange(this.props.field.updateValue(item.value));
	}
}

interface BooleanDropDownValue {
	label: string,
	value: Option<boolean>
}
